// extracted by mini-css-extract-plugin
export default {"button":"css_button__jsSR4","disabled":"css_disabled__C7Guh","text":"css_text__FgobG","hideTextOnMobile":"css_hideTextOnMobile__ib42z","icon":"css_icon__er8YK"};